<template>
<div class="quiz-start quiz-intro">
  <div class="header-img"></div>
  <h1>{{quiz.title}}</h1>

  <div class="quiz-description col-sm-auto">
    <p class="mb-4">
      Segmentacja ilościowa wyłoniła <strong>SZEŚĆ</strong> bardzo wyraźnych
      i&nbsp;jednocześnie spójnych wewnętrznie segmentów <strong>Młodych Dorosłych</strong>.
    </p>
    <p>
      Wypełnij krótki Quiz, sprawdź do którego segmentu należysz
      i&nbsp;dowiedz się jakie są kluczowe cechy Twojego segmentu.
    </p>
    <p>
      Możesz użyć myszki, klawiszy 1-5 lub wskazać na ekranie.
    </p>
  </div>

  <div class="quiz-nav">
    <button
      class="btn btn-primary btn-quiz-start"
      @click="$emit('start')">{{ $t('start_quiz') }}
    </button>
  </div>

</div>
</template>

<script>
export default {
  name: 'Start',
  props: ['quiz'],

  mounted() {
    // Keydown listener (start Quiz with ENTER or SPACE)
    document.addEventListener('keydown', this.onKeydownOnQuizStartTemplate);
    // document.addEventListener('touchend', this.onTouchstart);
  },

  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },

  methods: {
    onKeydownOnQuizStartTemplate(event) {
      // check if start page
      const quizStart = document.querySelector('.quiz-start');
      const displayed = quizStart.style.display !== 'none';

      if (!displayed) {
        return;
      }

      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      const btnStart = document.querySelector('.btn-quiz-start');

      if (btnStart) {
        btnStart.click();
      }
    },
  },
};
</script>

<style scoped>
.header-img {
  height: 140px;
  width: 100%;
  background: url('~@/assets/images/large-group-of-people-new.jpeg') center top no-repeat;
  background-size: cover;
  margin-bottom: 1.7em;
}

.quiz-nav {
  text-align: center;
}

.btn-quiz-start {
  margin: 20px auto 0;
  height: 2rem;
  padding: 1.5em 3em !important;
  line-height: 0.2em !important;
}

.quiz-start h1 {
  text-align: center;
  margin-bottom: .8em;
}

.quiz-start h1::after {
  display: block;
  content: "";
  position: relative;
  left: 0;
  bottom: 0;
  width: 200px;
  max-width: 80%;
  height: 1px;
  border-bottom: 2px solid var(--color-primary);
  margin: 0 auto;
  padding: 8px 0;
}

.logos-img {
  max-width: 700px;
}

</style>
